
import {getken} from '@/api/getToken';
import wx from 'weixin-js-sdk';
import {promptMessage,fetch} from '../../api/dataHandling';
import {urlConfig} from '../../api/urlConfig';
import axios from 'axios';
import logoImg from './image/38313311071575808.png';
import title from './image/title1.png';
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {

data(){
return {
logoImg,
title,
confirmTxt:'',
votebtn:false,
confirmshow:false,
votedoctorData:{
no:'',
remark:'',
name:'',
descirption:'',
votetimes:'',
},
votedCounts:'',
votedPersonCounts:'',
loadingshow:true,
doctorData:[
{
}
]
}

},
computed: {
reversedMessage: function (obj) {

return 'front.wh.jinxin-fertility.com/doctorImg/' + obj;
}
},
components: {
Grid, GridItem,Alert,Confirm, Loading,Radio, XButton
},
directives: {
TransferDom
},
methods:{
getopenid(code){
let cutton = 'http://front.wh.jinxin-fertility.com/pregnancyRegistration';
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;
window.localStorage.setItem('openid',this.openid);
getken(this.getUserId);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},
onConfirm(){

this.loadingshow = true;
if(this.confirmId && this.personInfoId && this.openid){
fetch('post',urlConfig.getsaveurl +'&voteDId=' +  this.confirmId + '&personInfoId=' + this.personInfoId +'&openId='+this.openid).then(response => {
this.loadingshow = false;
promptMessage('提示','投票成功！',this.alertHide());
}).catch(error => {
this.loadingshow = false;
})
}else {
if(!this.personInfoId || !this.openid){
promptMessage('提示','为获取到您的信息，请关闭页面重试！');
}else if(!this.confirmId){
promptMessage('提示','为获取到医生信息，请关闭页面重试！');
}
}

},//确认投票
getvoteNum(){
fetch('post',urlConfig.getnumurl).then(response => {
this.votedCounts = response.votedCounts;
this.votedPersonCounts = response.votedPersonCounts;
}).catch(error => {

})
}, //获取已投票票数
getUserId(){
/* this.openid = 'o8hchv0yVPqMpSQzm6jBrhCe5KcU';*/
fetch('post',urlConfig.GetSfzh+ '?openid='+this.openid).then(response => {

this.getPersonInfoId(response.sfzh);

}).catch(error => {

})
},  //获取 personInfoId
getPersonInfoId(sfzh){
fetch('post',urlConfig.GetPersonInfoId +'?sfzh='+sfzh).then(response => {

this.personInfoId = response.personInfoId;
this.getvoteNum();
this.getvotedoctor();
this.getdoctor();
}).catch(error => {

})

},
getvotedoctor(){
fetch('post',urlConfig.getvotedoctorurl +'&openId='+this.openid).then(response => {
/* console.log(response,0)*/
this.votedoctorData = response.tpInfodList;
if(response.canVote){  //能投票

this.votebtn = true;
}else{  // 不能投票
this.votebtn = false;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},  //已投票医生
getdoctor(){
fetch('post',urlConfig.doctorVoteGeturl).then(response => {
this.doctorData = response.tpInfoDList;
this.loadingshow = false;
console.log(this.doctorData)
}).catch(error => {
this.loadingshow = false;
})
}, //获取医生列表
alertHide(){
return function(){
window.location.reload();
}
},
voteClick(id,name){
this.confirmTxt = name;
this.confirmshow = true;
this.confirmId = id;
}, //投票
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
}
},
mounted(){
var _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
console.log(location.href)
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
if(window.localStorage.getItem('openid')){
_this.openid = window.localStorage.getItem('openid');
getken(_this.getUserId);
}else{
_this.getopenid(_this.$route.query.code)
}

}

wx.config({
debug: false,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
appId: _this.weixindata.appId,
jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems']
});
}).catch(function (error) {
promptMessage('提示' +error)

});
}
}



// WEBPACK FOOTER //
// ./src/project/voteProject/doctorVote1.vue